import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { Region } from '@modules/types/graphql';

export type Entity = Region | null;

@DecribeEntity('RegionEntity')
class RegionEntity extends BaseEntity {
    id: string;
    name: string;

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.name = entity?.name ?? '';
    }
}

export { RegionEntity };
